import React from 'react';
import {
  Col,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

export const ActionMenu = ({ cell, handleTicketsClick }) => {
  return (
    <Col sm={12}>
      <div className='border-top border-top-dashed'>
        <Row>
          <Col sm={12}>
            <UncontrolledDropdown className='float-end'>
              <DropdownToggle
                tag='a'
                className='btn btn-soft-secondary btn-sm'
                aria-label='More actions'
              >
                <i className='ri-more-line align-middle' aria-hidden='true'></i>
              </DropdownToggle>
              <DropdownMenu className='dropdown-menu-end'>
                <li>
                  <DropdownItem href='/apps-tickets-details'>
                    <i className='ri-eye-line align-middle me-2 text-muted'></i>{' '}
                    View
                  </DropdownItem>
                </li>
                <li>
                  <DropdownItem
                    className='edit-item-btn'
                    href='#showModal'
                    data-bs-toggle='modal'
                    onClick={() => {
                      const TicketData = cell.row.original;
                      handleTicketsClick(TicketData);
                    }}
                  >
                    <i className='ri-edit-line align-middle me-2 text-muted'></i>{' '}
                    Edit
                  </DropdownItem>
                </li>

                {/* <li>
                                    <DropdownItem className="remove-item-btn" data-bs-toggle="modal" href="#deleteOrder"
                                        onClick={() => {
                                            const ticketData = cell.row.original;
                                            onClickDelete(ticketData);
                                        }}>
                                        <i className="ri-delete-bin-line align-middle me-2 text-muted"></i> Delete
                                    </DropdownItem>
                                </li> */}
              </DropdownMenu>
            </UncontrolledDropdown>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default ActionMenu;
